import React from 'react'

import { arrayOf, object, shape, string } from 'prop-types'

import arrowImage from 'images/discover/business_account/arrow-form.svg'
import cubeImage from 'images/discover/business_account/cube.svg'
import ellipseImage from 'images/discover/business_account/ellipse.svg'
import starImage from 'images/discover/business_account/star.svg'

import { FORM_ANCHOR_ID } from '../../constants'
import AccountForm from '../AccountForm/AccountForm'

function Hero({ hero, form }) {
  return (
    <section className="business-account-hero">
      <div className="discover-container business-account-hero__wrap">
        <div className="business-account-hero__content">
          <div className="business-account-hero__text">
            <h1 className="discover-heading cgt-heading-500">{hero.title}</h1>
            <ul className="business-account-hero__benefits">
              {hero.benefits.map(benefit => (
                <li key={benefit} className="business-account-hero__benefit cgt-body-lg">
                  <img src={starImage} alt="" width={24} height={24} className="business-account-hero__benefit-icon" />
                  {benefit}
                </li>
              ))}
            </ul>
          </div>
          <div className="business-account-hero__stats">
            {hero.stats.map(stat => (
              <div key={stat.value} className="discover-stat">
                <p className="discover-stat__value">{stat.value}</p>
                <p className="discover-stat__label cgt-body-lg">{stat.label}</p>
              </div>
            ))}
          </div>
          <img src={arrowImage} alt="" width={112} height={50} className="business-account-hero__arrow" />
        </div>
        <div id={FORM_ANCHOR_ID} className="business-account-hero__form discover-anchor">
          <img src={cubeImage} alt="" width={78} height={72} className="business-account-hero__cube" />
          <img src={ellipseImage} alt="" width={68} height={68} className="business-account-hero__ellipse" />
          <AccountForm form={form} />
        </div>
      </div>
    </section>
  )
}

Hero.propTypes = {
  hero: shape({
    title: string.isRequired,
    benefits: arrayOf(string).isRequired,
    stats: arrayOf(shape({ value: string.isRequired, label: string.isRequired })).isRequired,
  }).isRequired,
  form: object.isRequired,
}

export default Hero
